import { DepartamentType, UpdateDepartamentType } from "../../../types/Departament";
import { put } from "../../../utils/axios-config";
import { DEPARTAMENTS } from "../../../utils/constants";

export const updateDepartament = async (data:UpdateDepartamentType) => {
    return await put<UpdateDepartamentType, string>(DEPARTAMENTS, data);
};